import { useQuery } from "@tanstack/react-query";
import { getPostBySlug } from "../../api/apiStorefront";
import i18next from "i18next";

/**
 * Hook to fetch a single blog post by slug
 * @param {string} slug - Post slug
 */
export function useGetPostBySlug(slug) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["post", i18next.language, slug],
        queryFn: () => getPostBySlug(slug),
        retry: false,
        enabled: !!slug, // Only run when slug is provided
        staleTime: 1000 * 60 * 10, // 10 minutes
        cacheTime: 1000 * 60 * 15, // 15 minutes
    });

    const post = data?.data?.data || null;

    return { isLoading, error, post, refetch };
}
